<p-toast [breakpoints]="{ '420px': { width: '100%', right: '0', left: '0' } }"></p-toast>
<div class="display-outer">
    <p>Displaying data from <span>{{startdate | date:'MMM d, y' }} to {{ enddate | date:'MMM d, y' }}</span>
    </p>
    <div class="booking-inner" (click)="getTransactionsexport()">
        <img src="../../../../assets/images/export-list.svg" alt="Export list"/>
        <span>Export</span>
    </div>
</div>

<div class="date-filter">
    <form [formGroup]="searchForm">
        <div class="top-financial">
            <div class="one-time">
                <ul>
                    <li *ngFor="let option of bookingTypeOption">
                        <p-radioButton type="radio" id="{{option.value}}" formControlName="bookingType" [checked]
                            (click)="onBookingTypeChange(option.value)" [value]="option.value"></p-radioButton>
                        <label class="option-name" for="{{option.value}}">{{option.name}}</label>
                    </li>
                </ul>

            </div>
        </div>
        <div class="grid">
            <div *ngIf="isSuperAdmin()" class="col-12 lg:col-2">
                <div class="date-outer">
                    <label for="companies">Company<span class="custom-star">*</span></label>
                    <div class="custom-select2">
                        <div class="filter-parking header-filter financials-filter">
                            <p-multiSelect id="companies" [options]="companyList" formControlName="companies" optionLabel="name"
                                [defaultLabel]="'Select Companies'" (onChange)="onSelectionChange($event)"
                                [autoZIndex]="true">
                            </p-multiSelect>
                            <img src="assets/images/fill-dropdown.svg" alt="" />
                        </div>
                    </div>
                </div>
                <div *ngIf="showAsterisk" class="validation-error">This field is required*</div>
            </div>
            <div class="col-12 lg:col-2">
                <div class="date-outer">
                    <label for="parkingLots">Parking Location<span class="custom-star">*</span></label>
                    <div class="custom-select2">
                        <div class="filter-parking header-filter financials-filter">
                            <p-multiSelect id="parkingLots" [options]="parkingLotByStatesListWithAll" formControlName="parkingLots"
                                optionLabel="name" [defaultLabel]="'Select Parking Locations'" [autoZIndex]="true">
                            </p-multiSelect>
                            <img src="assets/images/fill-dropdown.svg" alt="" />
                        </div>
                    </div>
                </div>
                <div *ngIf="showParkingLotAsterisk" class="validation-error">This field is required*</div>
            </div>
            <div class="col-12 lg:col-2">
                <div class="date-outer">
                    <div class="range-tooltip">
                        <label for="dateRangeMessage">Date Range</label>
                        <app-tooltip id="dateRangeMessage" [tooltipMessage]="dateRangeMessage"></app-tooltip>
                    </div>

                    <div class="custom-select2 custom-curser">
                        <div class="filter-parking header-filter financials-filter">
                            <p-dropdown [options]="DateSlot" formControlName="dateRange" optionLabel="name"
                                optionValue="value" (onChange)="onDateSlotChange($event)"></p-dropdown>
                            <img src="assets/images/fill-dropdown.svg" alt="" />
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf='showPicker' class="col-12 lg:col-2">
                <div class="date-outer">
                    <label for="startDate">Start Date</label>
                    <div class="custom-select2 custom-curser custom-date-calender">
                        <div class="filter-parking header-filter">
                            <p-calendar id="startDate" #calendarTopStartDateRef formControlName="startDate"
                                [readonlyInput]="true" (onSelect)="startDateChange($event)" placeholder="Select Date"
                                (keydown.enter)="searchButton()" [appEnterKeyListener]="'start'"
                                inputId="startDateInput" dateFormat="M dd, yy"></p-calendar>
                            <img [calendarOpener]="calendarTopStartDateRef" src="assets/images/date-calender.png"
                                alt="calender" />
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf='showPicker' class="col-12 lg:col-2">
                <div class="date-outer">
                    <label for="endDate">End Date</label>
                    <div class="custom-select2 custom-curser custom-date-calender">
                        <div class="filter-parking header-filter">
                            <p-calendar id="endDate" #calendarTopEndDateRef formControlName="endDate" [minDate]="minDate"
                                dateFormat="M dd, yy" [readonlyInput]="true" placeholder="Select Date"
                                [appEnterKeyListener]="'end'" inputId="endDateInput"
                                (keydown.enter)="searchButton()"></p-calendar>
                            <img [calendarOpener]="calendarTopEndDateRef" src="assets/images/date-calender.png"
                                alt="calender" />
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="!isSuperAdmin() || (isSuperAdmin() && !showPicker) || (isSuperAdmin() && !showPicker && hideAdvanceFilter)"
                class="col-12 lg:col-2">
                <div class="date-outer">
                    <label for="paymentStatus">Payment Status</label>
                    <div class="custom-select2">
                        <div class="filter-parking header-filter financials-filter">
                            <p-dropdown [options]="paymentStatus" formControlName="paymentStatus" optionLabel="name"
                                optionValue="value"></p-dropdown>
                            <img src="assets/images/fill-dropdown.svg" alt="" />
                        </div>
                    </div>
                </div>
            </div>

            <div *ngIf="!showPicker" class="col-12 lg:col-2">
                <div class="date-outer">
                    <label for="invoiceNumber">Invoice Number</label>
                    <div class="custom-select2">
                        <div class="filter-parking header-filter">
                            <input (input)="numbersOnlyValidator($event)" type="text" formControlName="invoiceNumber"
                                maxlength="15" pInputText placeholder="Enter Invoice Number"
                                (keydown.enter)="searchButton()" />
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="!isSuperAdmin() && !showPicker" class="col-12 lg:col-2">
                <div class="date-outer">
                    <label for="invoiceNumber">Name</label>
                    <div class="custom-select2">
                        <div class="filter-parking header-filter">
                            <input (input)="numbersOnlyValidator($event)" type="text" formControlName="invoiceNumber"
                                maxlength="15" pInputText placeholder="Enter Name" (keydown.enter)="searchButton()" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 lg:col-1">
                <div class="date-outer-btn">
                    <div class="edit-outer">
                        <p-button styleClass="p-button search-button" label="Apply"
                            (onClick)="searchButton()"></p-button>

                    </div>
                </div>
            </div>
            <div class="col-12 lg:col-1">
                <div class="date-outer-btn">
                    <div class="edit-outer reset-btn">
                        <p-button styleClass="p-button  p-button-outlined" label="Reset" (onClick)="reset()"></p-button>
                    </div>
                </div>
            </div>
            <div *ngIf="isSuperAdmin() || !isSuperAdmin()" (click)="toggleHideAdvanceFilter()" class="hide-advance">
                <h5 *ngIf="!hideAdvanceFilter">Hide Advanced Filter</h5>
                <h5 *ngIf="hideAdvanceFilter && (isSuperAdmin() || showPicker)">Advanced Filter</h5>
            </div>

            <div *ngIf="isSuperAdmin() && !hideAdvanceFilter && showPicker" class="col-12 lg:col-2">
                <div class="date-outer">
                    <label for="paymentStatus">Payment Status</label>
                    <div class="custom-select2">
                        <div class="filter-parking header-filter financials-filter">
                            <p-dropdown [options]="paymentStatus" formControlName="paymentStatus" optionLabel="name"
                                optionValue="value"></p-dropdown>
                            <img src="assets/images/fill-dropdown.svg" alt="" />
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="!hideAdvanceFilter && showPicker" class="col-12 lg:col-2">
                <div class="date-outer">
                    <label for="invoiceNumber">Invoice Number</label>
                    <div class="custom-select2">
                        <div class="filter-parking header-filter">
                            <input (input)="numbersOnlyValidator($event)" type="text" formControlName="invoiceNumber"
                                maxlength="15" pInputText placeholder="Enter Invoice Number"
                                (keydown.enter)="searchButton()" />
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="(!hideAdvanceFilter && isSuperAdmin()) || (!hideAdvanceFilter && !isSuperAdmin() && showPicker)"
                class="col-12 lg:col-2">
                <div class="date-outer">
                    <label for="name">Name</label>
                    <div class="custom-select2">
                        <div class="filter-parking header-filter">
                            <input type="text" formControlName="name" maxlength="50" pInputText placeholder="Enter Name"
                                (keydown.enter)="searchButton()" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>

</div>

<div class="overview-outer">
    <div class="revenue-outer overview-border">
        <div class="vparking-outer Overview-inner">
            <div class="top-heading">
                <h4>Financials Overview</h4>
            </div>
            <p *ngIf="startdate && enddate" class="calendar-icon">
                <img src="assets/images/calendar-new.svg" alt="calender" />
                <span>{{ startdate | date:'MMM d, y' }} to {{ enddate | date:'MMM d, y' }}</span>
            </p>

        </div>

    </div>
    <div class="revenu-chart">
        <ng-container *ngIf="chartOptions; else noChartData">
            <p-chart type="line" height="400" [data]="revenueData" [options]="chartOptions"></p-chart>
        </ng-container>
        <ng-template #noChartData>
            <div class="no-graph-record"><p>No Record Found </p></div>
        </ng-template>
    </div>
</div>
<div class="driver-leaderb history-outer">
    <div class="grid">
        <div class="col-12 custom-spacing-right custom-leftright transaction-history">
            <div class="driver-outer">
                <div class="vparking-outer">
                    <div class="top-heading">
                        <h4>History</h4>
                    </div>
                    <div class="record-outer">
                        <div class="page-list filter-parking">
                            <p>Show
                                <p-dropdown [options]="CustomItemPerPageBy" (onChange)="onDropdownChange($event)"
                                    placeholder="10" optionLabel="name" optionValue="value"
                                    [(ngModel)]="SearchItemPerPageBy"></p-dropdown><img
                                    src="assets/images/fill-dropdown.svg" alt="" />
                                Records
                            </p>

                        </div>
                    </div>
                </div>
                <div class="dashboard-table custom-history tranaction-history">
                    <div class="card full-width-scroll">
                        <p-table id="tbl-top" [tableStyle]="{'min-width': '60rem'}" [value]="transactionlist"
                            [resizableColumns]="true" columnResizeMode="expand">
                            <ng-template pTemplate="header">
                                <tr>
                                    <th scope="col" class="driver-name">Name</th>
                                    <th scope="col" class="driver-email">Email</th>
                                    <th scope="col">Mobile Number</th>
                                    <th scope="col">User Type</th>
                                    <th scope="col">Company Name</th>
                                    <th scope="col">Parking Location</th>
                                    <th scope="col">Parking Address</th>
                                    <th scope="col">{{spotTypeMsg}}</th>
                                    <th scope="col">Spot Count</th>
                                    <th scope="col">LP Number</th>
                                    <th scope="col">Type</th>
                                    <th scope="col">Arrival Date & Time</th>
                                    <th scope="col">Departure Date & Time</th>
                                    <th scope="col">Time Zone</th>
                                    <th scope="col">Invoice No.</th>
                                    <th scope="col">Invoice Date</th>
                                    <th scope="col">Created Date</th>
                                    <th scope="col">Base Amount ($)</th>
                                    <th scope="col">Discount ($)</th>
                                    <th scope="col">Taxes ($)</th>
                                    <th scope="col">Credits ($)</th>
                                    <th scope="col">Transaction Fee ($)</th>
                                    <th scope="col">Exempt Taxes And Fees ($)</th>
                                    <th scope="col">Received ($)</th>
                                    <th scope="col">Net Amount ($)</th>
                                    <th scope="col">Payment Mode</th>
                                    <th scope="col">Received Date</th>
                                    <th scope="col">Received Time</th>
                                    <th scope="col">Refunded</th>
                                    <th scope="col">Refunded Date & Time</th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-rowData>
                                <tr class="border12">
                                    <td class="driver-name ">
                                        <div class="history-table">
                                            <img [src]="rowData.driverImagePath || account" alt="Driver">
                                            <p>{{ rowData.userType === 'Group Operator' ? rowData.groupCompanyName :
                                                rowData.driverName }}</p>
                                        </div>
                                    </td>
                                    <td>{{ rowData.driverEmail || '-' }}</td>
                                    <td>{{ rowData.phoneNumber || '-' }}</td>
                                    <td>{{ rowData.userType || '-' }}</td>
                                    <td>{{ rowData.companyName || '-'}}</td>
                                    <td>{{ rowData.parkingLotName || '-' }}</td>
                                    <td>{{rowData.parkingLotAddress || '-'}}</td>
                                    <td>{{rowData.equipmentType || '-'}}</td>
                                    <td>{{rowData.spotCount || '-'}}</td>

                                    <td>{{ rowData.licenseNumberPlate || '-'}}</td>
                                    <td>{{rowData.type || '-'}}</td>
                                    <td>{{rowData.startDate ? (rowData.startDate | date:'MMM d, y - HH:mm') : '-' }}
                                    </td>
                                    <td>{{rowData.endDate ? (rowData.endDate | date:'MMM d, y - HH:mm') : '-' }}</td>
                                    <td>{{rowData.timeZone ? (getTimeZoneAbbreviation(rowData.timeZone)) : '-'}}</td>
                                    <td>{{ rowData.invoiceNumber || '-' }}</td>
                                    <td>{{ rowData.invoiceDate ? (rowData.invoiceDate | date:'MMM d, y') : '-'
                                        }}</td>
                                    <td>{{rowData.createdDate? (rowData.createdDate | date:'MMM d, y - HH:mm'): '-'}}
                                    </td>
                                    <td>{{(rowData.amount | removeDecimal) || '-'}}</td>
                                    <td>{{ (rowData.discount + rowData.couponDiscount | removeDecimal) > 0 ?
                                        ((rowData.discount + rowData.couponDiscount) | removeDecimal) : '-' }}</td>
                                    <td>{{ ((rowData.taxAndFees | removeDecimal) > 0 )? (rowData.taxAndFees |
                                        removeDecimal) : '-'}}</td>
                                    <td>{{ ((rowData.usedCredit | removeDecimal) > 0) ?(rowData.usedCredit |
                                        removeDecimal) : '-'}}</td>
                                    <td>{{ ((rowData.transactionFees | removeDecimal) > 0) ?(rowData.transactionFees |
                                        removeDecimal) : '-'}}</td>
                                    <td>{{ (rowData.exemptTaxesAndFees | removeDecimal) || '-'}}</td>
                                    <td>{{ (rowData.receivedAmount | removeDecimal) || '-'}}</td>
                                    <td>{{(rowData.amountWithoutTransactionFees | removeDecimal) || '-'}}</td>
                                    <td>{{ (rowData.bookingPaymentMode | paymentModeValue) || '-'}}</td>
                                    <td>
                                        {{ rowData.receivedDate ? rowData.receivedDate.split(' - ')[0] : '-' }}
                                    </td>
                                    <td>
                                        {{ rowData.receivedDate ? rowData.receivedDate.split(' - ')[1] : '-' }}
                                    </td>
                                    <td>
                                        <div
                                            [ngClass]="{'custom-red': (rowData.refundAmount !== 0 || (rowData.receivedAmount | removeDecimal) === 0)}">
                                            {{ (rowData.receivedAmount | removeDecimal) === 0 ?
                                            (rowData.bookingStatusLabel === bookingStatusLabel.PAID
                                            ?
                                            '-' : 0) : rowData.refundAmount === 0 ? '-' : (rowData.refundAmount |
                                            removeDecimal) }}
                                        </div>
                                    </td>
                                    <td>
                                        <div class="refunded-text">{{ rowData.refundDate ? (rowData.refundDate |
                                            luxonFormat) : '-' }}</div>
                                    </td>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="emptymessage" let-columns>
                                <tr class="common-norecord">
                                    <td class="no-record" colspan="24">
                                        No Record Found
                                    </td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </div>
                </div>

                <div class="card flex justify-content-end custom-pagination transaction-outer"
                    *ngIf="transactionlist?.length>0">
                    <p-paginator [first]="first" [rows]="itemsPerPage" [totalRecords]="totalItems"
                        (onPageChange)="onPageChange($event)"></p-paginator>
                </div>
            </div>

        </div>

    </div>

</div>